import { render, staticRenderFns } from "./competitionLiveList.vue?vue&type=template&id=01cc2670&scoped=true"
import script from "./competitionLiveList.vue?vue&type=script&lang=ts"
export * from "./competitionLiveList.vue?vue&type=script&lang=ts"
import style0 from "./competitionLiveList.vue?vue&type=style&index=0&id=01cc2670&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cc2670",
  null
  
)

export default component.exports